import { IAreaChartSpec, ICommonChartSpec } from '@visactor/vchart';
import { VeOColor, VeOSymbolType } from '@visactor/vchart-ve-o-theme';

export const charts = [
  {
    title: 'Area Chart (Stacked)',
    description: [
      '填充色：10% 透明度纯色填充',
      '适用场景：主要用于表示不同时间段，多个数据占比大小的变化趋势，数据起始点为前一数据的 Y 轴终点',
    ],
    spec: {
      type: 'area',
      data: {
        values: [
          { type: 'Nail polish', country: 'Africa', value: 4229 },
          { type: 'Nail polish', country: 'EU', value: 4376 },
          { type: 'Nail polish', country: 'China', value: 3054 },
          { type: 'Eyebrow pencil', country: 'Africa', value: 3932 },
          { type: 'Eyebrow pencil', country: 'EU', value: 3987 },
          { type: 'Eyebrow pencil', country: 'China', value: 5067 },
          { type: 'Rouge', country: 'Africa', value: 5221 },
          { type: 'Rouge', country: 'EU', value: 3574 },
          { type: 'Rouge', country: 'China', value: 7004 },
          { type: 'Lipstick', country: 'Africa', value: 9256 },
          { type: 'Lipstick', country: 'EU', value: 4376 },
          { type: 'Lipstick', country: 'China', value: 9054 },
          { type: 'Eyeshadows', country: 'Africa', value: 3308 },
          { type: 'Eyeshadows', country: 'EU', value: 4572 },
          { type: 'Eyeshadows', country: 'China', value: 12043 },
          { type: 'Eyeliner', country: 'Africa', value: 5432 },
          { type: 'Eyeliner', country: 'EU', value: 3417 },
          { type: 'Eyeliner', country: 'China', value: 15067 },
          { type: 'Foundation', country: 'Africa', value: 13701 },
          { type: 'Foundation', country: 'EU', value: 5231 },
          { type: 'Foundation', country: 'China', value: 10119 },
          { type: 'Lip gloss', country: 'Africa', value: 4008 },
          { type: 'Lip gloss', country: 'EU', value: 4572 },
          { type: 'Lip gloss', country: 'China', value: 12043 },
          { type: 'Mascara', country: 'Africa', value: 18712 },
          { type: 'Mascara', country: 'EU', value: 6134 },
          { type: 'Mascara', country: 'China', value: 10419 },
        ],
      },
      stack: true,
      xField: 'type',
      yField: 'value',
      seriesField: 'country',
      legends: [
        {
          visible: true,
          item: {
            shape: { style: { symbolType: VeOSymbolType.linePoint } },
          },
        },
      ],
      crosshair: {
        xField: {
          visible: true,
          line: { type: 'line', style: { lineWidth: 1 } },
        },
        yField: { visible: false },
      },
      axes: [
        {
          type: 'band',
          orient: 'bottom',
          title: { visible: true },
          trimPadding: true,
        },
        { type: 'linear', orient: 'left', title: { visible: true } },
      ],
      dataZoom: { orient: 'bottom' },
      tooltip: {
        visible: true,
        style: {
          shape: {
            shapeType: VeOSymbolType.linePoint,
          },
        },
      },
    } as IAreaChartSpec,
  },
  {
    title: 'Area Chart',
    description: [
      '填充色：如果涉及多折线重叠，颜色渐变至透明（10%->0%），以避免面积重叠，可视性不佳',
      '适用场景：表示数量和时间变化的趋势，数据起始点都为Y轴初始点',
    ],
    spec: {
      type: 'area',
      data: {
        values: [
          { type: 'Nail polish', country: 'Africa', value: 4229 },
          { type: 'Nail polish', country: 'EU', value: 4376 },
          { type: 'Nail polish', country: 'China', value: 3054 },
          { type: 'Eyebrow pencil', country: 'Africa', value: 3932 },
          { type: 'Eyebrow pencil', country: 'EU', value: 3987 },
          { type: 'Eyebrow pencil', country: 'China', value: 5067 },
          { type: 'Rouge', country: 'Africa', value: 5221 },
          { type: 'Rouge', country: 'EU', value: 3574 },
          { type: 'Rouge', country: 'China', value: 7004 },
          { type: 'Lipstick', country: 'Africa', value: 9256 },
          { type: 'Lipstick', country: 'EU', value: 4376 },
          { type: 'Lipstick', country: 'China', value: 9054 },
          { type: 'Eyeshadows', country: 'Africa', value: 3308 },
          { type: 'Eyeshadows', country: 'EU', value: 4572 },
          { type: 'Eyeshadows', country: 'China', value: 12043 },
          { type: 'Eyeliner', country: 'Africa', value: 5432 },
          { type: 'Eyeliner', country: 'EU', value: 3417 },
          { type: 'Eyeliner', country: 'China', value: 15067 },
          { type: 'Foundation', country: 'Africa', value: 13701 },
          { type: 'Foundation', country: 'EU', value: 5231 },
          { type: 'Foundation', country: 'China', value: 10119 },
          { type: 'Lip gloss', country: 'Africa', value: 4008 },
          { type: 'Lip gloss', country: 'EU', value: 4572 },
          { type: 'Lip gloss', country: 'China', value: 12043 },
          { type: 'Mascara', country: 'Africa', value: 18712 },
          { type: 'Mascara', country: 'EU', value: 6134 },
          { type: 'Mascara', country: 'China', value: 10419 },
        ],
      },
      stack: false,
      xField: 'type',
      yField: 'value',
      seriesField: 'country',
      legends: [
        {
          visible: true,
          item: {
            shape: { style: { symbolType: VeOSymbolType.linePoint } },
          },
        },
      ],
      crosshair: {
        xField: {
          visible: true,
          line: { type: 'line', style: { lineWidth: 1 } },
        },
        yField: { visible: false },
      },
      axes: [
        {
          type: 'band',
          orient: 'bottom',
          title: { visible: true },
          trimPadding: true,
        },
        { type: 'linear', orient: 'left', title: { visible: true } },
      ],
      dataZoom: { orient: 'bottom' },
      tooltip: {
        visible: true,
        style: {
          shape: {
            shapeType: VeOSymbolType.linePoint,
          },
        },
      },
    } as IAreaChartSpec,
  },
  {
    title: 'Bar Chart',
    description: ['交互：hover 聚焦同组图元'],
    spec: {
      type: 'bar',
      data: [
        {
          id: 'barData',
          values: [
            {
              State: 'WY',
              Age: 'Under 5 Years',
              Population: 25635,
            },
            {
              State: 'WY',
              Age: '5 to 13 Years',
              Population: 1890,
            },
            {
              State: 'WY',
              Age: '14 to 17 Years',
              Population: 9314,
            },
            {
              State: 'DC',
              Age: 'Under 5 Years',
              Population: 30352,
            },
            {
              State: 'DC',
              Age: '5 to 13 Years',
              Population: 20439,
            },
            {
              State: 'DC',
              Age: '14 to 17 Years',
              Population: 10225,
            },
            {
              State: 'VT',
              Age: 'Under 5 Years',
              Population: 38253,
            },
            {
              State: 'VT',
              Age: '5 to 13 Years',
              Population: 42538,
            },
            {
              State: 'VT',
              Age: '14 to 17 Years',
              Population: 15757,
            },
            {
              State: 'ND',
              Age: 'Under 5 Years',
              Population: 51896,
            },
            {
              State: 'ND',
              Age: '5 to 13 Years',
              Population: 67358,
            },
            {
              State: 'ND',
              Age: '14 to 17 Years',
              Population: 18794,
            },
            {
              State: 'AK',
              Age: 'Under 5 Years',
              Population: 72083,
            },
            {
              State: 'AK',
              Age: '5 to 13 Years',
              Population: 85640,
            },
            {
              State: 'AK',
              Age: '14 to 17 Years',
              Population: 22153,
            },
          ],
        },
      ],
      xField: ['State', 'Age'],
      yField: 'Population',
      seriesField: 'Age',
      stack: false,
      legends: {
        visible: true,
      },
      axes: [
        { type: 'band', orient: 'bottom', trimPadding: true },
        { type: 'linear', orient: 'left' },
      ],
    },
  },
  {
    title: 'Bar Chart (Stacked)',
    description: ['交互：hover 聚焦同组图元'],
    spec: {
      type: 'bar',
      data: [
        {
          id: 'barData',
          values: [
            {
              State: 'WY',
              Age: 'Under 5 Years',
              Population: 25635,
            },
            {
              State: 'WY',
              Age: '5 to 13 Years',
              Population: 1890,
            },
            {
              State: 'WY',
              Age: '14 to 17 Years',
              Population: 9314,
            },
            {
              State: 'DC',
              Age: 'Under 5 Years',
              Population: 30352,
            },
            {
              State: 'DC',
              Age: '5 to 13 Years',
              Population: 20439,
            },
            {
              State: 'DC',
              Age: '14 to 17 Years',
              Population: 10225,
            },
            {
              State: 'VT',
              Age: 'Under 5 Years',
              Population: 38253,
            },
            {
              State: 'VT',
              Age: '5 to 13 Years',
              Population: 42538,
            },
            {
              State: 'VT',
              Age: '14 to 17 Years',
              Population: 15757,
            },
            {
              State: 'ND',
              Age: 'Under 5 Years',
              Population: 51896,
            },
            {
              State: 'ND',
              Age: '5 to 13 Years',
              Population: 67358,
            },
            {
              State: 'ND',
              Age: '14 to 17 Years',
              Population: 18794,
            },
            {
              State: 'AK',
              Age: 'Under 5 Years',
              Population: 72083,
            },
            {
              State: 'AK',
              Age: '5 to 13 Years',
              Population: 85640,
            },
            {
              State: 'AK',
              Age: '14 to 17 Years',
              Population: 22153,
            },
          ],
        },
      ],
      xField: 'State',
      yField: 'Population',
      seriesField: 'Age',
      stack: true,
      legends: {
        visible: true,
      },
      axes: [
        { type: 'band', orient: 'bottom', trimPadding: true },
        { type: 'linear', orient: 'left' },
      ],
    },
  },
  {
    title: 'Bar Chart (Scrollable)',
    spec: {
      type: 'bar',
      data: {
        values: [
          {
            x: 0,
            y: 1.2020804451630671,
            originXData: '2022-03-08',
            type: 'Social Penetration',
          },
          {
            x: 1,
            y: 1.911162758594358,
            originXData: '2022-03-09',
            type: 'Social Penetration',
          },
          {
            x: 2,
            y: 0.919293523406533,
            originXData: '2022-03-10',
            type: 'Social Penetration',
          },
          {
            x: 3,
            y: 1.613617931982911,
            originXData: '2022-03-11',
            type: 'Social Penetration',
          },
          {
            x: 4,
            y: 1.121445896148114,
            originXData: '2022-03-12',
            type: 'Social Penetration',
          },
          {
            x: 5,
            y: 0.527369749651032,
            originXData: '2022-03-13',
            type: 'Social Penetration',
          },
          {
            x: 6,
            y: 0.07991167814791,
            originXData: '2022-03-14',
            type: 'Social Penetration',
          },
          {
            x: 7,
            y: 0.29341332300751205,
            originXData: '2022-03-15',
            type: 'Social Penetration',
          },
          {
            x: 8,
            y: 1.103150404211427,
            originXData: '2022-03-16',
            type: 'Social Penetration',
          },
          {
            x: 9,
            y: 0.38285701953593604,
            originXData: '2022-03-17',
            type: 'Social Penetration',
          },
          {
            x: 10,
            y: 0.8908005339482421,
            originXData: '2022-03-18',
            type: 'Social Penetration',
          },
          {
            x: 11,
            y: 0.8379933951719881,
            originXData: '2022-03-19',
            type: 'Social Penetration',
          },
          {
            x: 12,
            y: 2.913059895355856,
            originXData: '2022-03-20',
            type: 'Social Penetration',
          },
          {
            x: 13,
            y: 1.245523794769467,
            originXData: '2022-03-21',
            type: 'Social Penetration',
          },
          {
            x: 14,
            y: 1.801955367373218,
            originXData: '2022-03-22',
            type: 'Social Penetration',
          },
          {
            x: 15,
            y: 30.25170429439274,
            originXData: '2022-03-23',
            type: 'Social Penetration',
          },
          {
            x: 16,
            y: 2.084831170978463,
            originXData: '2022-03-24',
            type: 'Social Penetration',
          },
          {
            x: 17,
            y: 0.8300684679922911,
            originXData: '2022-03-25',
            type: 'Social Penetration',
          },
          {
            x: 18,
            y: 5.057522939533747,
            originXData: '2022-03-26',
            type: 'Social Penetration',
          },
          {
            x: 19,
            y: 1.364245041731511,
            originXData: '2022-03-27',
            type: 'Social Penetration',
          },
          {
            x: 20,
            y: 0.429699282814745,
            originXData: '2022-03-28',
            type: 'Social Penetration',
          },
          {
            x: 21,
            y: 8.636960050981939,
            originXData: '2022-03-29',
            type: 'Social Penetration',
          },
          {
            x: 22,
            y: 0.31233481070398905,
            originXData: '2022-03-30',
            type: 'Social Penetration',
          },
          {
            x: 23,
            y: 0.8979576483673781,
            originXData: '2022-03-31',
            type: 'Social Penetration',
          },
          {
            x: 24,
            y: 1.187326287404249,
            originXData: '2022-04-01',
            type: 'Social Penetration',
          },
          {
            x: 25,
            y: 0.013251966153457001,
            originXData: '2022-04-02',
            type: 'Social Penetration',
          },
          {
            x: 26,
            y: 0.150440921215681,
            originXData: '2022-04-03',
            type: 'Social Penetration',
          },
          {
            x: 27,
            y: 1.437865757864698,
            originXData: '2022-04-04',
            type: 'Social Penetration',
          },
          {
            x: 28,
            y: 19.70534531285437,
            originXData: '2022-04-05',
            type: 'Social Penetration',
          },
          {
            x: 29,
            y: 1.068708512330189,
            originXData: '2022-04-06',
            type: 'Social Penetration',
          },
          {
            x: 30,
            y: 3.239083103313066,
            originXData: '2022-04-07',
            type: 'Social Penetration',
          },
          {
            x: 31,
            y: 3.609669038457516,
            originXData: '2022-04-08',
            type: 'Social Penetration',
          },
          {
            x: 32,
            y: 0.8581543303200471,
            originXData: '2022-04-09',
            type: 'Social Penetration',
          },
          {
            x: 33,
            y: 1.235338424517758,
            originXData: '2022-04-10',
            type: 'Social Penetration',
          },
          {
            x: 34,
            y: 0.615560300356359,
            originXData: '2022-04-11',
            type: 'Social Penetration',
          },
          {
            x: 35,
            y: 3.5445165395901572,
            originXData: '2022-04-12',
            type: 'Social Penetration',
          },
          {
            x: 36,
            y: 1.037776502324676,
            originXData: '2022-04-13',
            type: 'Social Penetration',
          },
          {
            x: 37,
            y: 0.534866532613768,
            originXData: '2022-04-14',
            type: 'Social Penetration',
          },
          {
            x: 38,
            y: 3.225952049483959,
            originXData: '2022-04-15',
            type: 'Social Penetration',
          },
          {
            x: 39,
            y: 12.278592894400722,
            originXData: '2022-04-16',
            type: 'Social Penetration',
          },
          {
            x: 40,
            y: 0.411460847135642,
            originXData: '2022-04-17',
            type: 'Social Penetration',
          },
          {
            x: 41,
            y: 0.304818623987116,
            originXData: '2022-04-18',
            type: 'Social Penetration',
          },
          {
            x: 42,
            y: 0.8929797309154061,
            originXData: '2022-04-19',
            type: 'Social Penetration',
          },
          {
            x: 43,
            y: 4.074891060179412,
            originXData: '2022-04-20',
            type: 'Social Penetration',
          },
          {
            x: 44,
            y: 0.902423656543305,
            originXData: '2022-04-21',
            type: 'Social Penetration',
          },
          {
            x: 45,
            y: 0.868968791964932,
            originXData: '2022-04-22',
            type: 'Social Penetration',
          },
          {
            x: 46,
            y: 0.598986391584271,
            originXData: '2022-04-23',
            type: 'Social Penetration',
          },
          {
            x: 47,
            y: 0.27570721725353503,
            originXData: '2022-04-24',
            type: 'Social Penetration',
          },
          {
            x: 48,
            y: 0.38518667923696703,
            originXData: '2022-04-25',
            type: 'Social Penetration',
          },
          {
            x: 49,
            y: 0.622049495688147,
            originXData: '2022-04-26',
            type: 'Social Penetration',
          },
          {
            x: 50,
            y: 3.540727101774814,
            originXData: '2022-04-27',
            type: 'Social Penetration',
          },
          {
            x: 51,
            y: 2.742513433824975,
            originXData: '2022-04-28',
            type: 'Social Penetration',
          },
          {
            x: 52,
            y: 1.621566806821747,
            originXData: '2022-04-29',
            type: 'Social Penetration',
          },
          {
            x: 53,
            y: 2.352493741253538,
            originXData: '2022-04-30',
            type: 'Social Penetration',
          },
          {
            x: 54,
            y: 0.023487873849160002,
            originXData: '2022-05-01',
            type: 'Social Penetration',
          },
          {
            x: 55,
            y: 9.85187760463177,
            originXData: '2022-05-02',
            type: 'Social Penetration',
          },
          {
            x: 56,
            y: 6.3835439206943,
            originXData: '2022-05-03',
            type: 'Social Penetration',
          },
          {
            x: 57,
            y: 2.897597920598689,
            originXData: '2022-05-04',
            type: 'Social Penetration',
          },
          {
            x: 58,
            y: 0.147546385656207,
            originXData: '2022-05-05',
            type: 'Social Penetration',
          },
          {
            x: 59,
            y: 4.668438202775402,
            originXData: '2022-05-06',
            type: 'Social Penetration',
          },
          {
            x: 60,
            y: 1.868897716467347,
            originXData: '2022-05-07',
            type: 'Social Penetration',
          },
          {
            x: 61,
            y: 1.356875902669512,
            originXData: '2022-05-08',
            type: 'Social Penetration',
          },
          {
            x: 62,
            y: 1.029882775112869,
            originXData: '2022-05-09',
            type: 'Social Penetration',
          },
          {
            x: 63,
            y: 1.079419585437788,
            originXData: '2022-05-10',
            type: 'Social Penetration',
          },
          {
            x: 64,
            y: 0.43374835866466704,
            originXData: '2022-05-11',
            type: 'Social Penetration',
          },
          {
            x: 65,
            y: 0.6884004244125861,
            originXData: '2022-05-12',
            type: 'Social Penetration',
          },
          {
            x: 66,
            y: 0.5513219132650721,
            originXData: '2022-05-13',
            type: 'Social Penetration',
          },
          {
            x: 67,
            y: 0.26075436773203503,
            originXData: '2022-05-14',
            type: 'Social Penetration',
          },
          {
            x: 68,
            y: 3.534068370760441,
            originXData: '2022-05-15',
            type: 'Social Penetration',
          },
          {
            x: 69,
            y: 1.051684273070894,
            originXData: '2022-05-16',
            type: 'Social Penetration',
          },
          {
            x: 70,
            y: 0.8574030868970931,
            originXData: '2022-05-17',
            type: 'Social Penetration',
          },
          {
            x: 71,
            y: 0.515497463894879,
            originXData: '2022-05-18',
            type: 'Social Penetration',
          },
          {
            x: 72,
            y: 0.9592457438221671,
            originXData: '2022-05-19',
            type: 'Social Penetration',
          },
          {
            x: 73,
            y: 0.069882250377393,
            originXData: '2022-05-20',
            type: 'Social Penetration',
          },
          {
            x: 74,
            y: 10.360352568974609,
            originXData: '2022-05-21',
            type: 'Social Penetration',
          },
          {
            x: 75,
            y: 1.112796751785197,
            originXData: '2022-05-22',
            type: 'Social Penetration',
          },
          {
            x: 76,
            y: 4.891916669440483,
            originXData: '2022-05-23',
            type: 'Social Penetration',
          },
          {
            x: 77,
            y: 0.09534096170855301,
            originXData: '2022-05-24',
            type: 'Social Penetration',
          },
          {
            x: 78,
            y: 17.21160548866725,
            originXData: '2022-05-25',
            type: 'Social Penetration',
          },
          {
            x: 79,
            y: 0.9890377076819251,
            originXData: '2022-05-26',
            type: 'Social Penetration',
          },
          {
            x: 80,
            y: 1.207578684423282,
            originXData: '2022-05-27',
            type: 'Social Penetration',
          },
          {
            x: 81,
            y: 15.265265813052475,
            originXData: '2022-05-28',
            type: 'Social Penetration',
          },
          {
            x: 82,
            y: 1.667919015486645,
            originXData: '2022-05-29',
            type: 'Social Penetration',
          },
          {
            x: 83,
            y: 2.232083847244808,
            originXData: '2022-05-30',
            type: 'Social Penetration',
          },
          {
            x: 84,
            y: 1.113011174076138,
            originXData: '2022-05-31',
            type: 'Social Penetration',
          },
          {
            x: 85,
            y: 0.9839213173080511,
            originXData: '2022-06-01',
            type: 'Social Penetration',
          },
          {
            x: 86,
            y: 3.618368394111176,
            originXData: '2022-06-02',
            type: 'Social Penetration',
          },
          {
            x: 87,
            y: 1.5240830060491182,
            originXData: '2022-06-03',
            type: 'Social Penetration',
          },
          {
            x: 88,
            y: 0.7108355579615261,
            originXData: '2022-06-04',
            type: 'Social Penetration',
          },
          {
            x: 89,
            y: 1.842738679408876,
            originXData: '2022-06-05',
            type: 'Social Penetration',
          },
          {
            x: 90,
            y: 2.968986726243696,
            originXData: '2022-06-06',
            type: 'Social Penetration',
          },
          {
            x: 91,
            y: 0.30957106038382504,
            originXData: '2022-06-07',
            type: 'Social Penetration',
          },
          {
            x: 92,
            y: 3.077870353397237,
            originXData: '2022-06-08',
            type: 'Social Penetration',
          },
          {
            x: 93,
            y: 0.460474051903736,
            originXData: '2022-06-09',
            type: 'Social Penetration',
          },
          {
            x: 94,
            y: 0.9248894668614721,
            originXData: '2022-06-10',
            type: 'Social Penetration',
          },
          {
            x: 95,
            y: 0.5170229174882011,
            originXData: '2022-06-11',
            type: 'Social Penetration',
          },
          {
            x: 96,
            y: 1.343310704782682,
            originXData: '2022-06-12',
            type: 'Social Penetration',
          },
          {
            x: 97,
            y: 4.213284444567541,
            originXData: '2022-06-13',
            type: 'Social Penetration',
          },
          {
            x: 98,
            y: 0.718083714760927,
            originXData: '2022-06-14',
            type: 'Social Penetration',
          },
          {
            x: 99,
            y: 2.443370806389791,
            originXData: '2022-06-15',
            type: 'Social Penetration',
          },
          {
            x: 100,
            y: 3.594231845735735,
            originXData: '2022-06-16',
            type: 'Social Penetration',
          },
          {
            x: 101,
            y: 1.113951398490715,
            originXData: '2022-06-17',
            type: 'Social Penetration',
          },
          {
            x: 102,
            y: 0.5614439322266921,
            originXData: '2022-06-18',
            type: 'Social Penetration',
          },
          {
            x: 103,
            y: 1.243458727745012,
            originXData: '2022-06-19',
            type: 'Social Penetration',
          },
          {
            x: 104,
            y: 1.31005897849395,
            originXData: '2022-06-20',
            type: 'Social Penetration',
          },
          {
            x: 105,
            y: 0.572744269459053,
            originXData: '2022-06-21',
            type: 'Social Penetration',
          },
          {
            x: 106,
            y: 24.581669047338767,
            originXData: '2022-06-22',
            type: 'Social Penetration',
          },
          {
            x: 107,
            y: 0.47413969565051606,
            originXData: '2022-06-23',
            type: 'Social Penetration',
          },
          {
            x: 108,
            y: 0.43416765009011604,
            originXData: '2022-06-24',
            type: 'Social Penetration',
          },
          {
            x: 109,
            y: 0.943163264857342,
            originXData: '2022-06-25',
            type: 'Social Penetration',
          },
          {
            x: 110,
            y: 0.233205152479134,
            originXData: '2022-06-26',
            type: 'Social Penetration',
          },
          {
            x: 111,
            y: 3.9663605369632933,
            originXData: '2022-06-27',
            type: 'Social Penetration',
          },
          {
            x: 112,
            y: 0.016605232459512002,
            originXData: '2022-06-28',
            type: 'Social Penetration',
          },
          {
            x: 113,
            y: 1.374134760412724,
            originXData: '2022-06-29',
            type: 'Social Penetration',
          },
          {
            x: 114,
            y: 0.715486103147415,
            originXData: '2022-06-30',
            type: 'Social Penetration',
          },
          {
            x: 115,
            y: 0.747532331413809,
            originXData: '2022-07-01',
            type: 'Social Penetration',
          },
          {
            x: 116,
            y: 0.8670766655477491,
            originXData: '2022-07-02',
            type: 'Social Penetration',
          },
          {
            x: 117,
            y: 0.392542368674532,
            originXData: '2022-07-03',
            type: 'Social Penetration',
          },
          {
            x: 118,
            y: 2.354765436840968,
            originXData: '2022-07-04',
            type: 'Social Penetration',
          },
          {
            x: 119,
            y: 0.25059554847566,
            originXData: '2022-07-05',
            type: 'Social Penetration',
          },
          {
            x: 120,
            y: 4.720665637767317,
            originXData: '2022-07-06',
            type: 'Social Penetration',
          },
          {
            x: 121,
            y: 0.646476205877439,
            originXData: '2022-07-07',
            type: 'Social Penetration',
          },
          {
            x: 122,
            y: 4.428354777598469,
            originXData: '2022-07-08',
            type: 'Social Penetration',
          },
          {
            x: 123,
            y: 1.502467804494858,
            originXData: '2022-07-09',
            type: 'Social Penetration',
          },
          {
            x: 124,
            y: 11.706734521216822,
            originXData: '2022-07-10',
            type: 'Social Penetration',
          },
          {
            x: 125,
            y: 1.153083534578196,
            originXData: '2022-07-11',
            type: 'Social Penetration',
          },
          {
            x: 126,
            y: 1.4863362021332551,
            originXData: '2022-07-12',
            type: 'Social Penetration',
          },
          {
            x: 127,
            y: 1.61896686341972,
            originXData: '2022-07-13',
            type: 'Social Penetration',
          },
          {
            x: 128,
            y: 49.60818750100216,
            originXData: '2022-07-14',
            type: 'Social Penetration',
          },
          {
            x: 129,
            y: 1.785205883890873,
            originXData: '2022-07-15',
            type: 'Social Penetration',
          },
          {
            x: 130,
            y: 0.715594243310775,
            originXData: '2022-07-16',
            type: 'Social Penetration',
          },
          {
            x: 131,
            y: 0.8147430610328651,
            originXData: '2022-07-17',
            type: 'Social Penetration',
          },
          {
            x: 132,
            y: 1.24545618431753,
            originXData: '2022-07-18',
            type: 'Social Penetration',
          },
          {
            x: 133,
            y: 0.083915091025848,
            originXData: '2022-07-19',
            type: 'Social Penetration',
          },
          {
            x: 134,
            y: 0.32701962372413,
            originXData: '2022-07-20',
            type: 'Social Penetration',
          },
          {
            x: 135,
            y: 0.722041044814348,
            originXData: '2022-07-21',
            type: 'Social Penetration',
          },
          {
            x: 136,
            y: 10.662811760936936,
            originXData: '2022-07-22',
            type: 'Social Penetration',
          },
          {
            x: 137,
            y: 0.364677770561312,
            originXData: '2022-07-23',
            type: 'Social Penetration',
          },
          {
            x: 138,
            y: 0.9157754804402811,
            originXData: '2022-07-24',
            type: 'Social Penetration',
          },
          {
            x: 139,
            y: 0.67849525511577,
            originXData: '2022-07-25',
            type: 'Social Penetration',
          },
          {
            x: 140,
            y: 1.330066578741473,
            originXData: '2022-07-26',
            type: 'Social Penetration',
          },
          {
            x: 141,
            y: 5.686664774275858,
            originXData: '2022-07-27',
            type: 'Social Penetration',
          },
          {
            x: 142,
            y: 0.22324041916141402,
            originXData: '2022-07-28',
            type: 'Social Penetration',
          },
          {
            x: 143,
            y: 2.476037411183793,
            originXData: '2022-07-29',
            type: 'Social Penetration',
          },
          {
            x: 144,
            y: 0.773637653847835,
            originXData: '2022-07-30',
            type: 'Social Penetration',
          },
          {
            x: 145,
            y: 0.169152723468269,
            originXData: '2022-07-31',
            type: 'Social Penetration',
          },
          {
            x: 146,
            y: 1.519627178758216,
            originXData: '2022-08-01',
            type: 'Social Penetration',
          },
          {
            x: 147,
            y: 3.545652606242915,
            originXData: '2022-08-02',
            type: 'Social Penetration',
          },
          {
            x: 148,
            y: 1.3404062798488199,
            originXData: '2022-08-03',
            type: 'Social Penetration',
          },
          {
            x: 149,
            y: 0.6530263834012761,
            originXData: '2022-08-04',
            type: 'Social Penetration',
          },
          {
            x: 150,
            y: 0.708729075421144,
            originXData: '2022-08-05',
            type: 'Social Penetration',
          },
          {
            x: 151,
            y: 11.986631123295103,
            originXData: '2022-08-06',
            type: 'Social Penetration',
          },
          {
            x: 152,
            y: 1.232939713701664,
            originXData: '2022-08-07',
            type: 'Social Penetration',
          },
          {
            x: 153,
            y: 0.530813431405317,
            originXData: '2022-08-08',
            type: 'Social Penetration',
          },
          {
            x: 154,
            y: 2.510188659097596,
            originXData: '2022-08-09',
            type: 'Social Penetration',
          },
          {
            x: 155,
            y: 1.622456744339298,
            originXData: '2022-08-10',
            type: 'Social Penetration',
          },
          {
            x: 156,
            y: 0.25962103068208003,
            originXData: '2022-08-11',
            type: 'Social Penetration',
          },
          {
            x: 157,
            y: 0.884113805589634,
            originXData: '2022-08-12',
            type: 'Social Penetration',
          },
          {
            x: 158,
            y: 8.624685230360152,
            originXData: '2022-08-13',
            type: 'Social Penetration',
          },
          {
            x: 159,
            y: 1.6498217904306332,
            originXData: '2022-08-14',
            type: 'Social Penetration',
          },
          {
            x: 160,
            y: 5.840124155766275,
            originXData: '2022-08-15',
            type: 'Social Penetration',
          },
          {
            x: 161,
            y: 2.405030143824614,
            originXData: '2022-08-16',
            type: 'Social Penetration',
          },
          {
            x: 162,
            y: 1.034391306438299,
            originXData: '2022-08-17',
            type: 'Social Penetration',
          },
          {
            x: 163,
            y: 4.703412413763946,
            originXData: '2022-08-18',
            type: 'Social Penetration',
          },
          {
            x: 164,
            y: 0.22138733877979702,
            originXData: '2022-08-19',
            type: 'Social Penetration',
          },
          {
            x: 165,
            y: 0.14621922149563202,
            originXData: '2022-08-20',
            type: 'Social Penetration',
          },
          {
            x: 166,
            y: 5.702011116768989,
            originXData: '2022-08-21',
            type: 'Social Penetration',
          },
          {
            x: 167,
            y: 2.289251748782675,
            originXData: '2022-08-22',
            type: 'Social Penetration',
          },
          {
            x: 168,
            y: 0.40156922050687605,
            originXData: '2022-08-23',
            type: 'Social Penetration',
          },
          {
            x: 169,
            y: 16.368686321533847,
            originXData: '2022-08-24',
            type: 'Social Penetration',
          },
          {
            x: 170,
            y: 17.325634435909638,
            originXData: '2022-08-25',
            type: 'Social Penetration',
          },
          {
            x: 171,
            y: 2.771994472181008,
            originXData: '2022-08-26',
            type: 'Social Penetration',
          },
          {
            x: 172,
            y: 2.705080627435551,
            originXData: '2022-08-27',
            type: 'Social Penetration',
          },
          {
            x: 173,
            y: 0.366184071525715,
            originXData: '2022-08-28',
            type: 'Social Penetration',
          },
          {
            x: 174,
            y: 0.192969279119436,
            originXData: '2022-08-29',
            type: 'Social Penetration',
          },
          {
            x: 175,
            y: 0.248116517168076,
            originXData: '2022-08-30',
            type: 'Social Penetration',
          },
          {
            x: 176,
            y: 0.7172605174280461,
            originXData: '2022-08-31',
            type: 'Social Penetration',
          },
          {
            x: 177,
            y: 0.259653267575217,
            originXData: '2022-09-01',
            type: 'Social Penetration',
          },
          {
            x: 178,
            y: 1.398428414171018,
            originXData: '2022-09-02',
            type: 'Social Penetration',
          },
          {
            x: 179,
            y: 1.7166677805176591,
            originXData: '2022-09-03',
            type: 'Social Penetration',
          },
          {
            x: 0,
            y: 0.7782279444864411,
            originXData: '2022-03-08',
            type: 'Engagement - Socialization',
          },
          {
            x: 1,
            y: 0.6970763116149991,
            originXData: '2022-03-09',
            type: 'Engagement - Socialization',
          },
          {
            x: 2,
            y: 0.6754510401577041,
            originXData: '2022-03-10',
            type: 'Engagement - Socialization',
          },
          {
            x: 3,
            y: 4.391274420824463,
            originXData: '2022-03-11',
            type: 'Engagement - Socialization',
          },
          {
            x: 4,
            y: 0.5827973501093221,
            originXData: '2022-03-12',
            type: 'Engagement - Socialization',
          },
          {
            x: 5,
            y: 0.321443063009525,
            originXData: '2022-03-13',
            type: 'Engagement - Socialization',
          },
          {
            x: 6,
            y: 0.9838146243033221,
            originXData: '2022-03-14',
            type: 'Engagement - Socialization',
          },
          {
            x: 7,
            y: 0.225492098355163,
            originXData: '2022-03-15',
            type: 'Engagement - Socialization',
          },
          {
            x: 8,
            y: 0.580792120371675,
            originXData: '2022-03-16',
            type: 'Engagement - Socialization',
          },
          {
            x: 9,
            y: 0.510579334822959,
            originXData: '2022-03-17',
            type: 'Engagement - Socialization',
          },
          {
            x: 10,
            y: 1.656998380732747,
            originXData: '2022-03-18',
            type: 'Engagement - Socialization',
          },
          {
            x: 11,
            y: 1.372238730132033,
            originXData: '2022-03-19',
            type: 'Engagement - Socialization',
          },
          {
            x: 12,
            y: 3.375041306488803,
            originXData: '2022-03-20',
            type: 'Engagement - Socialization',
          },
          {
            x: 13,
            y: 0.5770535812918991,
            originXData: '2022-03-21',
            type: 'Engagement - Socialization',
          },
          {
            x: 14,
            y: 2.562767955961243,
            originXData: '2022-03-22',
            type: 'Engagement - Socialization',
          },
          {
            x: 15,
            y: 60.10096481599735,
            originXData: '2022-03-23',
            type: 'Engagement - Socialization',
          },
          {
            x: 16,
            y: 2.824195229461953,
            originXData: '2022-03-24',
            type: 'Engagement - Socialization',
          },
          {
            x: 17,
            y: 0.37108301055861304,
            originXData: '2022-03-25',
            type: 'Engagement - Socialization',
          },
          {
            x: 18,
            y: 6.8131452572139555,
            originXData: '2022-03-26',
            type: 'Engagement - Socialization',
          },
          {
            x: 19,
            y: 0.993289299105189,
            originXData: '2022-03-27',
            type: 'Engagement - Socialization',
          },
          {
            x: 20,
            y: 0.27225365805664004,
            originXData: '2022-03-28',
            type: 'Engagement - Socialization',
          },
          {
            x: 21,
            y: 2.663368864789215,
            originXData: '2022-03-29',
            type: 'Engagement - Socialization',
          },
          {
            x: 22,
            y: 1.136502929086737,
            originXData: '2022-03-30',
            type: 'Engagement - Socialization',
          },
          {
            x: 23,
            y: 0.8268293005130081,
            originXData: '2022-03-31',
            type: 'Engagement - Socialization',
          },
          {
            x: 24,
            y: 1.2824253532703072,
            originXData: '2022-04-01',
            type: 'Engagement - Socialization',
          },
          {
            x: 25,
            y: 1.580091614771022,
            originXData: '2022-04-02',
            type: 'Engagement - Socialization',
          },
          {
            x: 26,
            y: 0.7793382242254321,
            originXData: '2022-04-03',
            type: 'Engagement - Socialization',
          },
          {
            x: 27,
            y: 0.34207119701235905,
            originXData: '2022-04-04',
            type: 'Engagement - Socialization',
          },
          {
            x: 28,
            y: 4.144335050792541,
            originXData: '2022-04-05',
            type: 'Engagement - Socialization',
          },
          {
            x: 29,
            y: 1.336025709304907,
            originXData: '2022-04-06',
            type: 'Engagement - Socialization',
          },
          {
            x: 30,
            y: 0.9037359185383671,
            originXData: '2022-04-07',
            type: 'Engagement - Socialization',
          },
          {
            x: 31,
            y: 13.698767079174356,
            originXData: '2022-04-08',
            type: 'Engagement - Socialization',
          },
          {
            x: 32,
            y: 1.11771091972957,
            originXData: '2022-04-09',
            type: 'Engagement - Socialization',
          },
          {
            x: 33,
            y: 0.5546236200208831,
            originXData: '2022-04-10',
            type: 'Engagement - Socialization',
          },
          {
            x: 34,
            y: 0.133505664394376,
            originXData: '2022-04-11',
            type: 'Engagement - Socialization',
          },
          {
            x: 35,
            y: 8.458105165611851,
            originXData: '2022-04-12',
            type: 'Engagement - Socialization',
          },
          {
            x: 36,
            y: 1.412321112593621,
            originXData: '2022-04-13',
            type: 'Engagement - Socialization',
          },
          {
            x: 37,
            y: 0.577163861285873,
            originXData: '2022-04-14',
            type: 'Engagement - Socialization',
          },
          {
            x: 38,
            y: 5.112791338669762,
            originXData: '2022-04-15',
            type: 'Engagement - Socialization',
          },
          {
            x: 39,
            y: 13.301401633991011,
            originXData: '2022-04-16',
            type: 'Engagement - Socialization',
          },
          {
            x: 40,
            y: 0.8194099242420241,
            originXData: '2022-04-17',
            type: 'Engagement - Socialization',
          },
          {
            x: 41,
            y: 0.601409275693432,
            originXData: '2022-04-18',
            type: 'Engagement - Socialization',
          },
          {
            x: 42,
            y: 0.932019259560644,
            originXData: '2022-04-19',
            type: 'Engagement - Socialization',
          },
          {
            x: 43,
            y: 3.6166710941152713,
            originXData: '2022-04-20',
            type: 'Engagement - Socialization',
          },
          {
            x: 44,
            y: 2.682237126638688,
            originXData: '2022-04-21',
            type: 'Engagement - Socialization',
          },
          {
            x: 45,
            y: 0.329339479566271,
            originXData: '2022-04-22',
            type: 'Engagement - Socialization',
          },
          {
            x: 46,
            y: 0.923756524041317,
            originXData: '2022-04-23',
            type: 'Engagement - Socialization',
          },
          {
            x: 47,
            y: 0.6601580208066361,
            originXData: '2022-04-24',
            type: 'Engagement - Socialization',
          },
          {
            x: 48,
            y: 2.037027697748363,
            originXData: '2022-04-25',
            type: 'Engagement - Socialization',
          },
          {
            x: 49,
            y: 0.803863499657206,
            originXData: '2022-04-26',
            type: 'Engagement - Socialization',
          },
          {
            x: 50,
            y: 0.651469202290988,
            originXData: '2022-04-27',
            type: 'Engagement - Socialization',
          },
          {
            x: 51,
            y: 2.6893975459595643,
            originXData: '2022-04-28',
            type: 'Engagement - Socialization',
          },
          {
            x: 52,
            y: 0.9147556633717211,
            originXData: '2022-04-29',
            type: 'Engagement - Socialization',
          },
          {
            x: 53,
            y: 3.463127996997362,
            originXData: '2022-04-30',
            type: 'Engagement - Socialization',
          },
          {
            x: 54,
            y: 0.5573480476128151,
            originXData: '2022-05-01',
            type: 'Engagement - Socialization',
          },
          {
            x: 55,
            y: 35.95040240058573,
            originXData: '2022-05-02',
            type: 'Engagement - Socialization',
          },
          {
            x: 56,
            y: 5.577920982650984,
            originXData: '2022-05-03',
            type: 'Engagement - Socialization',
          },
          {
            x: 57,
            y: 5.106082630695584,
            originXData: '2022-05-04',
            type: 'Engagement - Socialization',
          },
          {
            x: 58,
            y: 0.040771286126692,
            originXData: '2022-05-05',
            type: 'Engagement - Socialization',
          },
          {
            x: 59,
            y: 0.23681078820699203,
            originXData: '2022-05-06',
            type: 'Engagement - Socialization',
          },
          {
            x: 60,
            y: 1.727448921279463,
            originXData: '2022-05-07',
            type: 'Engagement - Socialization',
          },
          {
            x: 61,
            y: 1.434740383567053,
            originXData: '2022-05-08',
            type: 'Engagement - Socialization',
          },
          {
            x: 62,
            y: 0.9377192673786531,
            originXData: '2022-05-09',
            type: 'Engagement - Socialization',
          },
          {
            x: 63,
            y: 0.5840348488590831,
            originXData: '2022-05-10',
            type: 'Engagement - Socialization',
          },
          {
            x: 64,
            y: 0.01643698693241,
            originXData: '2022-05-11',
            type: 'Engagement - Socialization',
          },
          {
            x: 65,
            y: 1.538028843999251,
            originXData: '2022-05-12',
            type: 'Engagement - Socialization',
          },
          {
            x: 66,
            y: 1.063801968030616,
            originXData: '2022-05-13',
            type: 'Engagement - Socialization',
          },
          {
            x: 67,
            y: 0.16980099784180802,
            originXData: '2022-05-14',
            type: 'Engagement - Socialization',
          },
          {
            x: 68,
            y: 2.144086432206532,
            originXData: '2022-05-15',
            type: 'Engagement - Socialization',
          },
          {
            x: 69,
            y: 1.152664833294427,
            originXData: '2022-05-16',
            type: 'Engagement - Socialization',
          },
          {
            x: 70,
            y: 0.8751363341872681,
            originXData: '2022-05-17',
            type: 'Engagement - Socialization',
          },
          {
            x: 71,
            y: 0.8615187586650901,
            originXData: '2022-05-18',
            type: 'Engagement - Socialization',
          },
          {
            x: 72,
            y: 0.126354125202296,
            originXData: '2022-05-19',
            type: 'Engagement - Socialization',
          },
          {
            x: 73,
            y: 0.7098481312166951,
            originXData: '2022-05-20',
            type: 'Engagement - Socialization',
          },
          {
            x: 74,
            y: 17.706030110118455,
            originXData: '2022-05-21',
            type: 'Engagement - Socialization',
          },
          {
            x: 75,
            y: 0.9176470910577301,
            originXData: '2022-05-22',
            type: 'Engagement - Socialization',
          },
          {
            x: 76,
            y: 16.47452431770853,
            originXData: '2022-05-23',
            type: 'Engagement - Socialization',
          },
          {
            x: 77,
            y: 0.7854768368577231,
            originXData: '2022-05-24',
            type: 'Engagement - Socialization',
          },
          {
            x: 78,
            y: 34.373177238596014,
            originXData: '2022-05-25',
            type: 'Engagement - Socialization',
          },
          {
            x: 79,
            y: 0.789535076533531,
            originXData: '2022-05-26',
            type: 'Engagement - Socialization',
          },
          {
            x: 80,
            y: 0.5312851260232421,
            originXData: '2022-05-27',
            type: 'Engagement - Socialization',
          },
          {
            x: 81,
            y: 12.028735185645875,
            originXData: '2022-05-28',
            type: 'Engagement - Socialization',
          },
          {
            x: 82,
            y: 1.439873268216485,
            originXData: '2022-05-29',
            type: 'Engagement - Socialization',
          },
          {
            x: 83,
            y: 3.827653889831506,
            originXData: '2022-05-30',
            type: 'Engagement - Socialization',
          },
          {
            x: 84,
            y: 1.4295696272440521,
            originXData: '2022-05-31',
            type: 'Engagement - Socialization',
          },
          {
            x: 85,
            y: 1.325995589464272,
            originXData: '2022-06-01',
            type: 'Engagement - Socialization',
          },
          {
            x: 86,
            y: 0.627748977148721,
            originXData: '2022-06-02',
            type: 'Engagement - Socialization',
          },
          {
            x: 87,
            y: 0.83151391784571,
            originXData: '2022-06-03',
            type: 'Engagement - Socialization',
          },
          {
            x: 88,
            y: 0.011530713721830002,
            originXData: '2022-06-04',
            type: 'Engagement - Socialization',
          },
          {
            x: 89,
            y: 1.130871471288951,
            originXData: '2022-06-05',
            type: 'Engagement - Socialization',
          },
          {
            x: 90,
            y: 2.9958102236757282,
            originXData: '2022-06-06',
            type: 'Engagement - Socialization',
          },
          {
            x: 91,
            y: 0.44026116440941004,
            originXData: '2022-06-07',
            type: 'Engagement - Socialization',
          },
          {
            x: 92,
            y: 4.156128784010092,
            originXData: '2022-06-08',
            type: 'Engagement - Socialization',
          },
          {
            x: 93,
            y: 1.2828566287818242,
            originXData: '2022-06-09',
            type: 'Engagement - Socialization',
          },
          {
            x: 94,
            y: 0.23152297348937,
            originXData: '2022-06-10',
            type: 'Engagement - Socialization',
          },
          {
            x: 95,
            y: 1.344093064443273,
            originXData: '2022-06-11',
            type: 'Engagement - Socialization',
          },
          {
            x: 96,
            y: 0.42108731154009404,
            originXData: '2022-06-12',
            type: 'Engagement - Socialization',
          },
          {
            x: 97,
            y: 2.448703044357372,
            originXData: '2022-06-13',
            type: 'Engagement - Socialization',
          },
          {
            x: 98,
            y: 1.912454128957958,
            originXData: '2022-06-14',
            type: 'Engagement - Socialization',
          },
          {
            x: 99,
            y: 0.010368540480550002,
            originXData: '2022-06-15',
            type: 'Engagement - Socialization',
          },
          {
            x: 100,
            y: 0.6677966564200211,
            originXData: '2022-06-16',
            type: 'Engagement - Socialization',
          },
          {
            x: 101,
            y: 0.11111864432229301,
            originXData: '2022-06-17',
            type: 'Engagement - Socialization',
          },
          {
            x: 102,
            y: 0.806546956486733,
            originXData: '2022-06-18',
            type: 'Engagement - Socialization',
          },
          {
            x: 103,
            y: 1.135192118212662,
            originXData: '2022-06-19',
            type: 'Engagement - Socialization',
          },
          {
            x: 104,
            y: 1.045144309632654,
            originXData: '2022-06-20',
            type: 'Engagement - Socialization',
          },
          {
            x: 105,
            y: 1.076475248295982,
            originXData: '2022-06-21',
            type: 'Engagement - Socialization',
          },
          {
            x: 106,
            y: 24.02021682920061,
            originXData: '2022-06-22',
            type: 'Engagement - Socialization',
          },
          {
            x: 107,
            y: 0.027051327125384002,
            originXData: '2022-06-23',
            type: 'Engagement - Socialization',
          },
          {
            x: 108,
            y: 2.878601660092219,
            originXData: '2022-06-24',
            type: 'Engagement - Socialization',
          },
          {
            x: 109,
            y: 0.019465090936308,
            originXData: '2022-06-25',
            type: 'Engagement - Socialization',
          },
          {
            x: 110,
            y: 1.2557471231721191,
            originXData: '2022-06-26',
            type: 'Engagement - Socialization',
          },
          {
            x: 111,
            y: 0.5849212901405391,
            originXData: '2022-06-27',
            type: 'Engagement - Socialization',
          },
          {
            x: 112,
            y: 0.280224773927022,
            originXData: '2022-06-28',
            type: 'Engagement - Socialization',
          },
          {
            x: 113,
            y: 0.751739223993092,
            originXData: '2022-06-29',
            type: 'Engagement - Socialization',
          },
          {
            x: 114,
            y: 0.555444809676618,
            originXData: '2022-06-30',
            type: 'Engagement - Socialization',
          },
          {
            x: 115,
            y: 1.043273887199711,
            originXData: '2022-07-01',
            type: 'Engagement - Socialization',
          },
          {
            x: 116,
            y: 1.8724388596735242,
            originXData: '2022-07-02',
            type: 'Engagement - Socialization',
          },
          {
            x: 117,
            y: 1.204834846410795,
            originXData: '2022-07-03',
            type: 'Engagement - Socialization',
          },
          {
            x: 118,
            y: 0.147183599628016,
            originXData: '2022-07-04',
            type: 'Engagement - Socialization',
          },
          {
            x: 119,
            y: 0.259954349350673,
            originXData: '2022-07-05',
            type: 'Engagement - Socialization',
          },
          {
            x: 120,
            y: 2.071271452074246,
            originXData: '2022-07-06',
            type: 'Engagement - Socialization',
          },
          {
            x: 121,
            y: 0.186466306558064,
            originXData: '2022-07-07',
            type: 'Engagement - Socialization',
          },
          {
            x: 122,
            y: 7.997827905255312,
            originXData: '2022-07-08',
            type: 'Engagement - Socialization',
          },
          {
            x: 123,
            y: 0.33362085354833704,
            originXData: '2022-07-09',
            type: 'Engagement - Socialization',
          },
          {
            x: 124,
            y: 36.550441521853145,
            originXData: '2022-07-10',
            type: 'Engagement - Socialization',
          },
          {
            x: 125,
            y: 0.337559642243531,
            originXData: '2022-07-11',
            type: 'Engagement - Socialization',
          },
          {
            x: 126,
            y: 0.48307852351030106,
            originXData: '2022-07-12',
            type: 'Engagement - Socialization',
          },
          {
            x: 127,
            y: 0.9387594299650791,
            originXData: '2022-07-13',
            type: 'Engagement - Socialization',
          },
          {
            x: 128,
            y: 22.940238837323303,
            originXData: '2022-07-14',
            type: 'Engagement - Socialization',
          },
          {
            x: 129,
            y: 0.631304013521069,
            originXData: '2022-07-15',
            type: 'Engagement - Socialization',
          },
          {
            x: 130,
            y: 0.984028805544615,
            originXData: '2022-07-16',
            type: 'Engagement - Socialization',
          },
          {
            x: 131,
            y: 0.26284189122074103,
            originXData: '2022-07-17',
            type: 'Engagement - Socialization',
          },
          {
            x: 132,
            y: 1.082826448671828,
            originXData: '2022-07-18',
            type: 'Engagement - Socialization',
          },
          {
            x: 133,
            y: 0.5880718113215341,
            originXData: '2022-07-19',
            type: 'Engagement - Socialization',
          },
          {
            x: 134,
            y: 0.17041520446782002,
            originXData: '2022-07-20',
            type: 'Engagement - Socialization',
          },
          {
            x: 135,
            y: 0.822598941600809,
            originXData: '2022-07-21',
            type: 'Engagement - Socialization',
          },
          {
            x: 136,
            y: 0.183634003906628,
            originXData: '2022-07-22',
            type: 'Engagement - Socialization',
          },
          {
            x: 137,
            y: 0.559247300094862,
            originXData: '2022-07-23',
            type: 'Engagement - Socialization',
          },
          {
            x: 138,
            y: 1.091835974661574,
            originXData: '2022-07-24',
            type: 'Engagement - Socialization',
          },
          {
            x: 139,
            y: 3.048531280160542,
            originXData: '2022-07-25',
            type: 'Engagement - Socialization',
          },
          {
            x: 140,
            y: 1.582638082613582,
            originXData: '2022-07-26',
            type: 'Engagement - Socialization',
          },
          {
            x: 141,
            y: 6.436173309221049,
            originXData: '2022-07-27',
            type: 'Engagement - Socialization',
          },
          {
            x: 142,
            y: 1.428578028660132,
            originXData: '2022-07-28',
            type: 'Engagement - Socialization',
          },
          {
            x: 143,
            y: 0.7249411790805861,
            originXData: '2022-07-29',
            type: 'Engagement - Socialization',
          },
          {
            x: 144,
            y: 0.9265499876312321,
            originXData: '2022-07-30',
            type: 'Engagement - Socialization',
          },
          {
            x: 145,
            y: 0.9014047551998651,
            originXData: '2022-07-31',
            type: 'Engagement - Socialization',
          },
          {
            x: 146,
            y: 1.610068186750942,
            originXData: '2022-08-01',
            type: 'Engagement - Socialization',
          },
          {
            x: 147,
            y: 2.330031081649702,
            originXData: '2022-08-02',
            type: 'Engagement - Socialization',
          },
          {
            x: 148,
            y: 0.462815961543229,
            originXData: '2022-08-03',
            type: 'Engagement - Socialization',
          },
          {
            x: 149,
            y: 0.08597037675761801,
            originXData: '2022-08-04',
            type: 'Engagement - Socialization',
          },
          {
            x: 150,
            y: 3.581243043200601,
            originXData: '2022-08-05',
            type: 'Engagement - Socialization',
          },
          {
            x: 151,
            y: 10.930286916614767,
            originXData: '2022-08-06',
            type: 'Engagement - Socialization',
          },
          {
            x: 152,
            y: 1.8029857915415932,
            originXData: '2022-08-07',
            type: 'Engagement - Socialization',
          },
          {
            x: 153,
            y: 2.014631665755229,
            originXData: '2022-08-08',
            type: 'Engagement - Socialization',
          },
          {
            x: 154,
            y: 2.983415297830412,
            originXData: '2022-08-09',
            type: 'Engagement - Socialization',
          },
          {
            x: 155,
            y: 1.289582374551249,
            originXData: '2022-08-10',
            type: 'Engagement - Socialization',
          },
          {
            x: 156,
            y: 0.37516694909806303,
            originXData: '2022-08-11',
            type: 'Engagement - Socialization',
          },
          {
            x: 157,
            y: 1.603259620438238,
            originXData: '2022-08-12',
            type: 'Engagement - Socialization',
          },
          {
            x: 158,
            y: 3.3791466219930433,
            originXData: '2022-08-13',
            type: 'Engagement - Socialization',
          },
          {
            x: 159,
            y: 2.627126072551769,
            originXData: '2022-08-14',
            type: 'Engagement - Socialization',
          },
          {
            x: 160,
            y: 3.354483317899366,
            originXData: '2022-08-15',
            type: 'Engagement - Socialization',
          },
          {
            x: 161,
            y: 1.444879535922397,
            originXData: '2022-08-16',
            type: 'Engagement - Socialization',
          },
          {
            x: 162,
            y: 0.6369673400603011,
            originXData: '2022-08-17',
            type: 'Engagement - Socialization',
          },
          {
            x: 163,
            y: 0.5990722583580821,
            originXData: '2022-08-18',
            type: 'Engagement - Socialization',
          },
          {
            x: 164,
            y: 0.24079634787311602,
            originXData: '2022-08-19',
            type: 'Engagement - Socialization',
          },
          {
            x: 165,
            y: 0.096627004274573,
            originXData: '2022-08-20',
            type: 'Engagement - Socialization',
          },
          {
            x: 166,
            y: 11.782408392531364,
            originXData: '2022-08-21',
            type: 'Engagement - Socialization',
          },
          {
            x: 167,
            y: 1.846139752930779,
            originXData: '2022-08-22',
            type: 'Engagement - Socialization',
          },
          {
            x: 168,
            y: 2.44670175499675,
            originXData: '2022-08-23',
            type: 'Engagement - Socialization',
          },
          {
            x: 169,
            y: 9.285256494681935,
            originXData: '2022-08-24',
            type: 'Engagement - Socialization',
          },
          {
            x: 170,
            y: 40.63547963350666,
            originXData: '2022-08-25',
            type: 'Engagement - Socialization',
          },
          {
            x: 171,
            y: 1.432898057334553,
            originXData: '2022-08-26',
            type: 'Engagement - Socialization',
          },
          {
            x: 172,
            y: 1.140228551443707,
            originXData: '2022-08-27',
            type: 'Engagement - Socialization',
          },
          {
            x: 173,
            y: 0.37561791103581305,
            originXData: '2022-08-28',
            type: 'Engagement - Socialization',
          },
          {
            x: 174,
            y: 1.203078886727172,
            originXData: '2022-08-29',
            type: 'Engagement - Socialization',
          },
          {
            x: 175,
            y: 0.901524977902984,
            originXData: '2022-08-30',
            type: 'Engagement - Socialization',
          },
          {
            x: 176,
            y: 0.22721632248943202,
            originXData: '2022-08-31',
            type: 'Engagement - Socialization',
          },
          {
            x: 177,
            y: 2.040817156148029,
            originXData: '2022-09-01',
            type: 'Engagement - Socialization',
          },
          {
            x: 178,
            y: 0.071469482611002,
            originXData: '2022-09-02',
            type: 'Engagement - Socialization',
          },
          {
            x: 179,
            y: 1.903668070163285,
            originXData: '2022-09-03',
            type: 'Engagement - Socialization',
          },
        ],
      },
      xField: ['x', 'type'],
      yField: 'y',
      seriesField: 'type',
      axes: [
        { orient: 'bottom', type: 'band', trimPadding: true },
        { orient: 'left', type: 'linear' },
      ],
      barMinWidth: 1,
      autoBandSize: true,
      scrollBar: [
        {
          orient: 'bottom',
          auto: true,
          roam: true,
        },
      ],
      legends: [{ visible: true }],
    },
  },
  {
    title: 'Area Chart (Stacked percentage)',
    spec: {
      type: 'area',
      data: {
        values: [
          { type: 'Nail polish', country: 'Africa', value: 4229 },
          { type: 'Nail polish', country: 'EU', value: 4376 },
          { type: 'Nail polish', country: 'China', value: 3054 },
          { type: 'Nail polish', country: 'Other Country 1', value: 4054 },
          { type: 'Nail polish', country: 'Other Country 2', value: 2054 },
          { type: 'Nail polish', country: 'Other Country 3', value: 4054 },
          { type: 'Nail polish', country: 'Other Country 4', value: 3054 },
          { type: 'Nail polish', country: 'Other Country 5', value: 2054 },
          { type: 'Nail polish', country: 'Other Country 6', value: 4054 },
          { type: 'Nail polish', country: 'Other Country 7', value: 3054 },
          { type: 'Eyebrow pencil', country: 'Africa', value: 3932 },
          { type: 'Eyebrow pencil', country: 'EU', value: 3987 },
          { type: 'Eyebrow pencil', country: 'China', value: 5067 },
          { type: 'Eyebrow pencil', country: 'Other Country 1', value: 3067 },
          { type: 'Eyebrow pencil', country: 'Other Country 2', value: 4067 },
          { type: 'Eyebrow pencil', country: 'Other Country 3', value: 5067 },
          { type: 'Eyebrow pencil', country: 'Other Country 4', value: 4067 },
          { type: 'Eyebrow pencil', country: 'Other Country 5', value: 3067 },
          { type: 'Eyebrow pencil', country: 'Other Country 6', value: 5067 },
          { type: 'Eyebrow pencil', country: 'Other Country 7', value: 2067 },
          { type: 'Rouge', country: 'Africa', value: 5221 },
          { type: 'Rouge', country: 'EU', value: 3574 },
          { type: 'Rouge', country: 'China', value: 7004 },
          { type: 'Rouge', country: 'Other Country 1', value: 5004 },
          { type: 'Rouge', country: 'Other Country 2', value: 6004 },
          { type: 'Rouge', country: 'Other Country 3', value: 7004 },
          { type: 'Rouge', country: 'Other Country 4', value: 6004 },
          { type: 'Rouge', country: 'Other Country 5', value: 4004 },
          { type: 'Rouge', country: 'Other Country 6', value: 5004 },
          { type: 'Rouge', country: 'Other Country 7', value: 6004 },
          { type: 'Lipstick', country: 'Africa', value: 9256 },
          { type: 'Lipstick', country: 'EU', value: 4376 },
          { type: 'Lipstick', country: 'China', value: 9054 },
          { type: 'Lipstick', country: 'Other Country 1', value: 8054 },
          { type: 'Lipstick', country: 'Other Country 2', value: 6054 },
          { type: 'Lipstick', country: 'Other Country 3', value: 5054 },
          { type: 'Lipstick', country: 'Other Country 4', value: 7054 },
          { type: 'Lipstick', country: 'Other Country 5', value: 4054 },
          { type: 'Lipstick', country: 'Other Country 6', value: 5054 },
          { type: 'Lipstick', country: 'Other Country 7', value: 6054 },
          { type: 'Eyeshadows', country: 'Africa', value: 3308 },
          { type: 'Eyeshadows', country: 'EU', value: 4572 },
          { type: 'Eyeshadows', country: 'China', value: 12043 },
          { type: 'Eyeshadows', country: 'Other Country 1', value: 6043 },
          { type: 'Eyeshadows', country: 'Other Country 2', value: 3043 },
          { type: 'Eyeshadows', country: 'Other Country 3', value: 7043 },
          { type: 'Eyeshadows', country: 'Other Country 4', value: 4043 },
          { type: 'Eyeshadows', country: 'Other Country 5', value: 5043 },
          { type: 'Eyeshadows', country: 'Other Country 6', value: 4043 },
          { type: 'Eyeshadows', country: 'Other Country 7', value: 5043 },
          { type: 'Eyeliner', country: 'Africa', value: 5432 },
          { type: 'Eyeliner', country: 'EU', value: 3417 },
          { type: 'Eyeliner', country: 'China', value: 15067 },
          { type: 'Eyeliner', country: 'Other Country 1', value: 6067 },
          { type: 'Eyeliner', country: 'Other Country 2', value: 7067 },
          { type: 'Eyeliner', country: 'Other Country 3', value: 8067 },
          { type: 'Eyeliner', country: 'Other Country 4', value: 3067 },
          { type: 'Eyeliner', country: 'Other Country 5', value: 5067 },
          { type: 'Eyeliner', country: 'Other Country 6', value: 6067 },
          { type: 'Eyeliner', country: 'Other Country 7', value: 7067 },
          { type: 'Foundation', country: 'Africa', value: 13701 },
          { type: 'Foundation', country: 'EU', value: 5231 },
          { type: 'Foundation', country: 'China', value: 10119 },
          { type: 'Foundation', country: 'Other Country 1', value: 5119 },
          { type: 'Foundation', country: 'Other Country 2', value: 7119 },
          { type: 'Foundation', country: 'Other Country 3', value: 7119 },
          { type: 'Foundation', country: 'Other Country 4', value: 6119 },
          { type: 'Foundation', country: 'Other Country 5', value: 7119 },
          { type: 'Foundation', country: 'Other Country 6', value: 6119 },
          { type: 'Foundation', country: 'Other Country 7', value: 8119 },
          { type: 'Lip gloss', country: 'Africa', value: 4008 },
          { type: 'Lip gloss', country: 'EU', value: 4572 },
          { type: 'Lip gloss', country: 'China', value: 12043 },
          { type: 'Lip gloss', country: 'Other Country 1', value: 6043 },
          { type: 'Lip gloss', country: 'Other Country 2', value: 5043 },
          { type: 'Lip gloss', country: 'Other Country 3', value: 7043 },
          { type: 'Lip gloss', country: 'Other Country 4', value: 8043 },
          { type: 'Lip gloss', country: 'Other Country 5', value: 5043 },
          { type: 'Lip gloss', country: 'Other Country 6', value: 6043 },
          { type: 'Lip gloss', country: 'Other Country 7', value: 7043 },
          { type: 'Mascara', country: 'Africa', value: 18712 },
          { type: 'Mascara', country: 'EU', value: 6134 },
          { type: 'Mascara', country: 'China', value: 10419 },
          { type: 'Mascara', country: 'Other Country 1', value: 5419 },
          { type: 'Mascara', country: 'Other Country 2', value: 6419 },
          { type: 'Mascara', country: 'Other Country 3', value: 7419 },
          { type: 'Mascara', country: 'Other Country 4', value: 8419 },
          { type: 'Mascara', country: 'Other Country 5', value: 5419 },
          { type: 'Mascara', country: 'Other Country 6', value: 6419 },
          { type: 'Mascara', country: 'Other Country 7', value: 9419 },
        ],
      },
      stack: true,
      percent: true,
      xField: 'type',
      yField: 'value',
      seriesField: 'country',
      legends: [
        {
          visible: true,
          item: {
            shape: { style: { symbolType: VeOSymbolType.linePoint } },
          },
        },
      ],
      crosshair: {
        xField: {
          visible: true,
          line: { type: 'line', style: { lineWidth: 1 } },
        },
        yField: { visible: false },
      },
      axes: [
        {
          type: 'band',
          orient: 'bottom',
          trimPadding: true,
          title: { visible: true },
        },
        { type: 'linear', orient: 'left', title: { visible: true } },
      ],
      dataZoom: { orient: 'bottom' },
      tooltip: {
        visible: true,
        style: {
          shape: {
            shapeType: VeOSymbolType.linePoint,
          },
        },
      },
    } as IAreaChartSpec,
  },
  {
    title: 'Mark Line',
    description: ['样式：提供 5 档默认颜色，用于表达不同的紧急程度'],
    spec: {
      type: 'scatter',
      xField: 'x',
      yField: 'y',
      sizeField: 'z',
      data: {
        id: 'data',
        values: [
          { x: 95, y: 95, z: 13.8, name: 'BE', country: 'Belgium' },
          { x: 86.5, y: 102.9, z: 14.7, name: 'DE', country: 'Germany' },
          { x: 80.8, y: 91.5, z: 15.8, name: 'FI', country: 'Finland' },
          { x: 80.4, y: 102.5, z: 12, name: 'NL', country: 'Netherlands' },
          { x: 80.3, y: 86.1, z: 11.8, name: 'SE', country: 'Sweden' },
          { x: 78.4, y: 70.1, z: 16.6, name: 'ES', country: 'Spain' },
          { x: 74.2, y: 68.5, z: 14.5, name: 'FR', country: 'France' },
          { x: 73.5, y: 83.1, z: 10, name: 'NO', country: 'Norway' },
          { x: 71, y: 93.2, z: 24.7, name: 'UK', country: 'United Kingdom' },
          { x: 69.2, y: 57.6, z: 10.4, name: 'IT', country: 'Italy' },
          { x: 68.6, y: 20, z: 16, name: 'RU', country: 'Russia' },
          { x: 65.5, y: 126.4, z: 35.3, name: 'US', country: 'United States' },
          { x: 65.4, y: 50.8, z: 28.5, name: 'HU', country: 'Hungary' },
          { x: 63.4, y: 51.8, z: 15.4, name: 'PT', country: 'Portugal' },
          { x: 64, y: 82.9, z: 31.3, name: 'NZ', country: 'New Zealand' },
        ],
      },
      size: {
        type: 'linear',
        range: [20, 80],
      },
      axes: [
        { orient: 'bottom', type: 'linear', min: 60, max: 95 },
        { orient: 'left', type: 'linear', min: 0, max: 200 },
      ],
      label: {
        visible: true,
        position: 'center',
        overlap: {
          avoidBaseMark: false,
        },
      },
      markLine: [
        {
          x: 85,
        },
        {
          y: 50,
          line: { style: { stroke: VeOColor.safe } },
          startSymbol: { style: { fill: VeOColor.safe } },
        },
        {
          y: 90,
          line: { style: { stroke: VeOColor.notice } },
          startSymbol: { style: { fill: VeOColor.notice } },
        },
        {
          y: 120,
          line: { style: { stroke: VeOColor.warning } },
          startSymbol: { style: { fill: VeOColor.warning } },
        },
        {
          y: 140,
          line: { style: { stroke: VeOColor.critical } },
          startSymbol: { style: { fill: VeOColor.critical } },
        },
        {
          y: 160,
          line: { style: { stroke: VeOColor.fatal } },
          startSymbol: { style: { fill: VeOColor.fatal } },
        },
      ],
    },
  },
  {
    title: 'Mark Area',
    description: [
      '样式：推荐使用 markArea 和 markLine 组合的形式，markLine 为分界线',
    ],
    spec: {
      type: 'line',
      xField: 'Date',
      yField: 'Price',
      data: {
        id: 'data',
        values: [
          { Date: 'Jan-13', Price: 0.129 },
          { Date: 'Feb-13', Price: 0.129 },
          { Date: 'Mar-13', Price: 0.128 },
          { Date: 'Apr-13', Price: 0.128 },
          { Date: 'May-13', Price: 0.131 },
          { Date: 'Jun-13', Price: 0.137 },
          { Date: 'Jul-13', Price: 0.137 },
          { Date: 'Aug-13', Price: 0.137 },
          { Date: 'Sep-13', Price: 0.137 },
          { Date: 'Oct-13', Price: 0.132 },
          { Date: 'Nov-13', Price: 0.13 },
          { Date: 'Dec-13', Price: 0.131 },
          { Date: 'Jan-14', Price: 0.134 },
          { Date: 'Feb-14', Price: 0.134 },
          { Date: 'Mar-14', Price: 0.135 },
          { Date: 'Apr-14', Price: 0.131 },
          { Date: 'May-14', Price: 0.136 },
          { Date: 'Jun-14', Price: 0.143 },
          { Date: 'Jul-14', Price: 0.143 },
          { Date: 'Aug-14', Price: 0.143 },
          { Date: 'Sep-14', Price: 0.141 },
          { Date: 'Oct-14', Price: 0.136 },
          { Date: 'Nov-14', Price: 0.134 },
          { Date: 'Dec-14', Price: 0.135 },
          { Date: 'Jan-15', Price: 0.138 },
          { Date: 'Feb-15', Price: 0.138 },
          { Date: 'Mar-15', Price: 0.136 },
          { Date: 'Apr-15', Price: 0.137 },
          { Date: 'May-15', Price: 0.137 },
          { Date: 'Jun-15', Price: 0.143 },
          { Date: 'Jul-15', Price: 0.142 },
          { Date: 'Aug-15', Price: 0.142 },
          { Date: 'Sep-15', Price: 0.141 },
          { Date: 'Oct-15', Price: 0.136 },
          { Date: 'Nov-15', Price: 0.134 },
          { Date: 'Dec-15', Price: 0.133 },
          { Date: 'Jan-16', Price: 0.134 },
          { Date: 'Feb-16', Price: 0.134 },
          { Date: 'Mar-16', Price: 0.134 },
          { Date: 'Apr-16', Price: 0.134 },
          { Date: 'May-16', Price: 0.133 },
          { Date: 'Jun-16', Price: 0.138 },
          { Date: 'Jul-16', Price: 0.139 },
          { Date: 'Aug-16', Price: 0.139 },
          { Date: 'Sep-16', Price: 0.139 },
          { Date: 'Oct-16', Price: 0.134 },
          { Date: 'Nov-16', Price: 0.131 },
          { Date: 'Dec-16', Price: 0.133 },
          { Date: 'Jan-17', Price: 0.134 },
          { Date: 'Feb-17', Price: 0.135 },
          { Date: 'Mar-17', Price: 0.134 },
          { Date: 'Apr-17', Price: 0.135 },
          { Date: 'May-17', Price: 0.137 },
          { Date: 'Jun-17', Price: 0.142 },
          { Date: 'Jul-17', Price: 0.143 },
          { Date: 'Aug-17', Price: 0.142 },
          { Date: 'Sep-17', Price: 0.142 },
          { Date: 'Oct-17', Price: 0.137 },
          { Date: 'Nov-17', Price: 0.136 },
          { Date: 'Dec-17', Price: 0.136 },
          { Date: 'Jan-18', Price: 0.135 },
          { Date: 'Feb-18', Price: 0.135 },
          { Date: 'Mar-18', Price: 0.135 },
          { Date: 'Apr-18', Price: 0.134 },
          { Date: 'May-18', Price: 0.136 },
          { Date: 'Jun-18', Price: 0.139 },
          { Date: 'Jul-18', Price: 0.139 },
          { Date: 'Aug-18', Price: 0.139 },
          { Date: 'Sep-18', Price: 0.138 },
          { Date: 'Oct-18', Price: 0.136 },
          { Date: 'Nov-18', Price: 0.134 },
          { Date: 'Dec-18', Price: 0.135 },
          { Date: 'Jan-19', Price: 0.135 },
          { Date: 'Feb-19', Price: 0.136 },
          { Date: 'Mar-19', Price: 0.135 },
          { Date: 'Apr-19', Price: 0.135 },
          { Date: 'May-19', Price: 0.136 },
          { Date: 'Jun-19', Price: 0.139 },
          { Date: 'Jul-19', Price: 0.14 },
          { Date: 'Aug-19', Price: 0.139 },
          { Date: 'Sep-19', Price: 0.139 },
          { Date: 'Oct-19', Price: 0.136 },
          { Date: 'Nov-19', Price: 0.133 },
          { Date: 'Dec-19', Price: 0.133 },
          { Date: 'Jan-20', Price: 0.134 },
          { Date: 'Feb-20', Price: 0.134 },
          { Date: 'Mar-20', Price: 0.134 },
          { Date: 'Apr-20', Price: 0.133 },
          { Date: 'May-20', Price: 0.134 },
          { Date: 'Jun-20', Price: 0.137 },
          { Date: 'Jul-20', Price: 0.137 },
          { Date: 'Aug-20', Price: 0.137 },
          { Date: 'Sep-20', Price: 0.137 },
          { Date: 'Oct-20', Price: 0.135 },
          { Date: 'Nov-20', Price: 0.136 },
          { Date: 'Dec-20', Price: 0.136 },
          { Date: 'Jan-21', Price: 0.136 },
          { Date: 'Feb-21', Price: 0.137 },
          { Date: 'Mar-21', Price: 0.138 },
          { Date: 'Apr-21', Price: 0.139 },
          { Date: 'May-21', Price: 0.14 },
          { Date: 'Jun-21', Price: 0.142 },
          { Date: 'Jul-21', Price: 0.143 },
          { Date: 'Aug-21', Price: 0.144 },
          { Date: 'Sep-21', Price: 0.144 },
          { Date: 'Oct-21', Price: 0.142 },
          { Date: 'Nov-21', Price: 0.142 },
          { Date: 'Dec-21', Price: 0.142 },
          { Date: 'Jan-22', Price: 0.147 },
          { Date: 'Feb-22', Price: 0.148 },
          { Date: 'Mar-22', Price: 0.15 },
          { Date: 'Apr-22', Price: 0.151 },
          { Date: 'May-22', Price: 0.154 },
          { Date: 'Jun-22', Price: 0.16 },
          { Date: 'Jul-22', Price: 0.164 },
          { Date: 'Aug-22', Price: 0.167 },
          { Date: 'Sep-22', Price: 0.167 },
          { Date: 'Oct-22', Price: 0.166 },
          { Date: 'Nov-22', Price: 0.163 },
          { Date: 'Dec-22', Price: 0.165 },
          { Date: 'Jan-23', Price: 0.168 },
          { Date: 'Feb-23', Price: 0.168 },
          { Date: 'Mar-23', Price: 0.166 },
        ],
      },
      axes: [
        { orient: 'left', min: 0.12, max: 0.18 },
        { type: 'band', orient: 'bottom', trimPadding: true },
      ],
      markArea: [
        {
          y: 0.14,
          y1: 0.16,
          area: { style: { fill: VeOColor.notice } },
        },
        {
          y: 0.16,
          y1: 0.17,
          area: { style: { fill: VeOColor.critical } },
        },
      ],
      markLine: [
        {
          y: 0.14,
          line: {
            style: {
              stroke: VeOColor.notice,
              lineWidth: 1,
              lineDash: [4, 4],
            },
          },
          startSymbol: { visible: false },
          label: {
            visible: true,
            position: 'start',
            text: '0.14',
            refY: 2,
            style: {
              fill: VeOColor.notice,
              textAlign: 'left',
              textBaseline: 'bottom',
            },
          },
        },
        {
          y: 0.16,
          line: {
            style: {
              stroke: VeOColor.critical,
              lineWidth: 1,
              lineDash: [4, 4],
            },
          },
          startSymbol: { visible: false },
          label: {
            visible: true,
            position: 'start',
            text: '0.16',
            refY: 2,
            style: {
              fill: VeOColor.critical,
              textAlign: 'left',
              textBaseline: 'bottom',
            },
          },
        },
      ],
      crosshair: {
        xField: {
          visible: true,
          line: { type: 'line', style: { lineWidth: 1 } },
        },
        yField: { visible: false },
      },
    },
  },
  {
    title: 'Mark Line Type 2',
    spec: {
      type: 'line',
      xField: 'Date',
      yField: 'Price',
      data: {
        id: 'data',
        values: [
          { Date: 'Jan-13', Price: 0.129 },
          { Date: 'Feb-13', Price: 0.129 },
          { Date: 'Mar-13', Price: 0.128 },
          { Date: 'Apr-13', Price: 0.128 },
          { Date: 'May-13', Price: 0.131 },
          { Date: 'Jun-13', Price: 0.137 },
          { Date: 'Jul-13', Price: 0.137 },
          { Date: 'Aug-13', Price: 0.137 },
          { Date: 'Sep-13', Price: 0.137 },
          { Date: 'Oct-13', Price: 0.132 },
          { Date: 'Nov-13', Price: 0.13 },
          { Date: 'Dec-13', Price: 0.131 },
          { Date: 'Jan-14', Price: 0.134 },
          { Date: 'Feb-14', Price: 0.134 },
          { Date: 'Mar-14', Price: 0.135 },
          { Date: 'Apr-14', Price: 0.131 },
          { Date: 'May-14', Price: 0.136 },
          { Date: 'Jun-14', Price: 0.143 },
          { Date: 'Jul-14', Price: 0.143 },
          { Date: 'Aug-14', Price: 0.143 },
          { Date: 'Sep-14', Price: 0.141 },
          { Date: 'Oct-14', Price: 0.136 },
          { Date: 'Nov-14', Price: 0.134 },
          { Date: 'Dec-14', Price: 0.135 },
          { Date: 'Jan-15', Price: 0.138 },
          { Date: 'Feb-15', Price: 0.138 },
          { Date: 'Mar-15', Price: 0.136 },
          { Date: 'Apr-15', Price: 0.137 },
          { Date: 'May-15', Price: 0.137 },
          { Date: 'Jun-15', Price: 0.143 },
          { Date: 'Jul-15', Price: 0.142 },
          { Date: 'Aug-15', Price: 0.142 },
          { Date: 'Sep-15', Price: 0.141 },
          { Date: 'Oct-15', Price: 0.136 },
          { Date: 'Nov-15', Price: 0.134 },
          { Date: 'Dec-15', Price: 0.133 },
          { Date: 'Jan-16', Price: 0.134 },
          { Date: 'Feb-16', Price: 0.134 },
          { Date: 'Mar-16', Price: 0.134 },
          { Date: 'Apr-16', Price: 0.134 },
          { Date: 'May-16', Price: 0.133 },
          { Date: 'Jun-16', Price: 0.138 },
          { Date: 'Jul-16', Price: 0.139 },
          { Date: 'Aug-16', Price: 0.139 },
          { Date: 'Sep-16', Price: 0.139 },
          { Date: 'Oct-16', Price: 0.134 },
          { Date: 'Nov-16', Price: 0.131 },
          { Date: 'Dec-16', Price: 0.133 },
          { Date: 'Jan-17', Price: 0.134 },
          { Date: 'Feb-17', Price: 0.135 },
          { Date: 'Mar-17', Price: 0.134 },
          { Date: 'Apr-17', Price: 0.135 },
          { Date: 'May-17', Price: 0.137 },
          { Date: 'Jun-17', Price: 0.142 },
          { Date: 'Jul-17', Price: 0.143 },
          { Date: 'Aug-17', Price: 0.142 },
          { Date: 'Sep-17', Price: 0.142 },
          { Date: 'Oct-17', Price: 0.137 },
          { Date: 'Nov-17', Price: 0.136 },
          { Date: 'Dec-17', Price: 0.136 },
          { Date: 'Jan-18', Price: 0.135 },
          { Date: 'Feb-18', Price: 0.135 },
          { Date: 'Mar-18', Price: 0.135 },
          { Date: 'Apr-18', Price: 0.134 },
          { Date: 'May-18', Price: 0.136 },
          { Date: 'Jun-18', Price: 0.139 },
          { Date: 'Jul-18', Price: 0.139 },
          { Date: 'Aug-18', Price: 0.139 },
          { Date: 'Sep-18', Price: 0.138 },
          { Date: 'Oct-18', Price: 0.136 },
          { Date: 'Nov-18', Price: 0.134 },
          { Date: 'Dec-18', Price: 0.135 },
          { Date: 'Jan-19', Price: 0.135 },
          { Date: 'Feb-19', Price: 0.136 },
          { Date: 'Mar-19', Price: 0.135 },
          { Date: 'Apr-19', Price: 0.135 },
          { Date: 'May-19', Price: 0.136 },
          { Date: 'Jun-19', Price: 0.139 },
          { Date: 'Jul-19', Price: 0.14 },
          { Date: 'Aug-19', Price: 0.139 },
          { Date: 'Sep-19', Price: 0.139 },
          { Date: 'Oct-19', Price: 0.136 },
          { Date: 'Nov-19', Price: 0.133 },
          { Date: 'Dec-19', Price: 0.133 },
          { Date: 'Jan-20', Price: 0.134 },
          { Date: 'Feb-20', Price: 0.134 },
          { Date: 'Mar-20', Price: 0.134 },
          { Date: 'Apr-20', Price: 0.133 },
          { Date: 'May-20', Price: 0.134 },
          { Date: 'Jun-20', Price: 0.137 },
          { Date: 'Jul-20', Price: 0.137 },
          { Date: 'Aug-20', Price: 0.137 },
          { Date: 'Sep-20', Price: 0.137 },
          { Date: 'Oct-20', Price: 0.135 },
          { Date: 'Nov-20', Price: 0.136 },
          { Date: 'Dec-20', Price: 0.136 },
          { Date: 'Jan-21', Price: 0.136 },
          { Date: 'Feb-21', Price: 0.137 },
          { Date: 'Mar-21', Price: 0.138 },
          { Date: 'Apr-21', Price: 0.139 },
          { Date: 'May-21', Price: 0.14 },
          { Date: 'Jun-21', Price: 0.142 },
          { Date: 'Jul-21', Price: 0.143 },
          { Date: 'Aug-21', Price: 0.144 },
          { Date: 'Sep-21', Price: 0.144 },
          { Date: 'Oct-21', Price: 0.142 },
          { Date: 'Nov-21', Price: 0.142 },
          { Date: 'Dec-21', Price: 0.142 },
          { Date: 'Jan-22', Price: 0.147 },
          { Date: 'Feb-22', Price: 0.148 },
          { Date: 'Mar-22', Price: 0.15 },
          { Date: 'Apr-22', Price: 0.151 },
          { Date: 'May-22', Price: 0.154 },
          { Date: 'Jun-22', Price: 0.16 },
          { Date: 'Jul-22', Price: 0.164 },
          { Date: 'Aug-22', Price: 0.167 },
          { Date: 'Sep-22', Price: 0.167 },
          { Date: 'Oct-22', Price: 0.166 },
          { Date: 'Nov-22', Price: 0.163 },
          { Date: 'Dec-22', Price: 0.165 },
          { Date: 'Jan-23', Price: 0.168 },
          { Date: 'Feb-23', Price: 0.168 },
          { Date: 'Mar-23', Price: 0.166 },
        ],
      },
      axes: [
        { orient: 'left', min: 0.12, max: 0.18 },
        { type: 'band', orient: 'bottom', trimPadding: true },
      ],
      markLine: [
        {
          y: 0.14,
          line: {
            style: {
              stroke: VeOColor.notice,
              lineWidth: 1,
              lineDash: [4, 4],
            },
          },
          startSymbol: { visible: false },
          label: {
            visible: true,
            position: 'start',
            text: '>0.14',
            style: {
              fill: VeOColor.notice,
              textAlign: 'left',
              textBaseline: 'bottom',
            },
            labelBackground: {
              visible: true,
              style: {
                cornerRadius: 0,
                fill: VeOColor.notice,
                fillOpacity: 0.1,
              },
            },
          },
        },
        {
          y: 0.16,
          line: {
            style: {
              stroke: VeOColor.critical,
              lineWidth: 1,
              lineDash: [4, 4],
            },
          },
          startSymbol: { visible: false },
          label: {
            visible: true,
            position: 'start',
            text: '>0.16',
            refY: 2,
            style: {
              fill: VeOColor.critical,
              textAlign: 'left',
              textBaseline: 'bottom',
            },
            labelBackground: {
              visible: true,
              style: {
                cornerRadius: 0,
                fill: VeOColor.critical,
                fillOpacity: 0.1,
              },
            },
          },
        },
      ],
      crosshair: {
        xField: {
          visible: true,
          line: { type: 'line', style: { lineWidth: 1 } },
        },
        yField: { visible: false },
      },
    },
  },
  {
    title: 'Pie Chart',
    spec: {
      type: 'pie',
      data: [
        {
          id: 'id0',
          values: [
            {
              type: 'oxygen',
              value: '46.60',
            },
            {
              type: 'silicon',
              value: '27.72',
            },
            {
              type: 'aluminum',
              value: '8.13',
            },
            {
              type: 'iron',
              value: '5',
            },
            {
              type: 'calcium',
              value: '3.63',
            },
            {
              type: 'sodium',
              value: '2.83',
            },
            {
              type: 'potassium',
              value: '2.59',
            },
            {
              type: 'others',
              value: '3.5',
            },
          ],
        },
      ],
      valueField: 'value',
      categoryField: 'type',
      legends: [
        {
          visible: true,
          item: {
            shape: { style: { symbolType: 'circle' } },
          },
        },
      ],
      label: {
        visible: true,
      },
      tooltip: {
        visible: true,
        style: {
          shape: {
            shapeType: 'circle',
          },
        },
      },
    },
  },
  {
    title: 'Scatter Chart',
    spec: (() => {
      const yearData: any = {};
      const firstYear = 1950;
      const lastYear = 2023;

      for (let year = firstYear; year <= lastYear; year++) {
        const data: any[] = [];
        yearData[year] = data;

        for (let i = 0; i < 50; i++) {
          if (year === firstYear) {
            data.push({
              x: Math.round(Math.random() * 100 - 90),
              y: Math.round(Math.random() * 100 - 90),
              value: Math.round(Math.random() * 1000),
              index: i,
            });
          } else {
            const previous = yearData[year - 1][i];
            data.push({
              x: previous.x + Math.round(Math.random() * 5 - 2 + i / 50),
              y: previous.y + Math.round(Math.random() * 5 - 2 + i / 50),
              value: Math.abs(
                previous.value + Math.round(Math.random() * 100 - 45)
              ),
              index: i,
            });
          }
        }
      }

      const specs = Object.values(yearData).map((data, index) => {
        return {
          data: [
            {
              id: 'id',
              values: data,
            },
            {
              id: 'year',
              values: [{ year: Object.keys(yearData)[index] }],
            },
          ],
        };
      });

      const DURATION = 300;

      return {
        type: 'common',
        player: {
          orient: 'bottom',
          auto: true,
          interval: DURATION,
          dy: 10,
          specs,
        },
        data: specs[0].data,
        region: [
          {
            clip: true,
          },
        ],
        axes: [
          {
            orient: 'left',
            type: 'linear',
            range: { min: -100, max: 100 },
          },
          {
            orient: 'bottom',
            type: 'linear',
            range: { min: -100, max: 100 },
          },
        ],
        series: [
          {
            type: 'scatter',
            // 通过数据中的 index 进行数据匹配
            dataKey: 'index',
            // 声明点半径大小
            sizeField: 'value',
            size: {
              type: 'linear',
              range: [5, 30],
            },
            xField: 'x',
            yField: 'y',
            animationAppear: {
              duration: DURATION,
              easing: 'linear',
            },
            animationUpdate: {
              duration: DURATION,
              easing: 'linear',
            },
          },
        ],
        crosshair: {
          xField: { visible: true },
          yField: { visible: true },
        },
        legends: {
          visible: true,
          type: 'size',
          orient: 'right',
          field: 'value',
          width: 100,
        } as any,
      } as ICommonChartSpec;
    })(),
  },
  {
    title: 'Rose Chart',
    spec: {
      type: 'rose',
      data: {
        id: '0',
        values: [
          {
            time: '2:00',
            value: 27,
            type: 'Sales',
          },
          {
            time: '6:00',
            value: 25,
            type: 'Sales',
          },
          {
            time: '10:00',
            value: 18,
            type: 'Sales',
          },
          {
            time: '14:00',
            value: 15,
            type: 'Sales',
          },
          {
            time: '18:00',
            value: 10,
            type: 'Sales',
          },
          {
            time: '22:00',
            value: 5,
            type: 'Sales',
          },
          {
            time: '2:00',
            value: 7,
            type: 'Discount',
          },
          {
            time: '6:00',
            value: 5,
            type: 'Discount',
          },
          {
            time: '10:00',
            value: 38,
            type: 'Discount',
          },
          {
            time: '14:00',
            value: 5,
            type: 'Discount',
          },
          {
            time: '18:00',
            value: 20,
            type: 'Discount',
          },
          {
            time: '22:00',
            value: 15,
            type: 'Discount',
          },
        ],
      },
      categoryField: ['time', 'type'],
      valueField: 'value',
      seriesField: 'type',
      outerRadius: 1,
      axes: [
        {
          orient: 'angle',
          domainLine: { visible: true },
          grid: { visible: true },
          label: {
            visible: true,
          },
        },
        {
          orient: 'radius',
          grid: { visible: true, smooth: true },
          label: {
            visible: true,
          },
        },
      ],
      crosshair: {
        categoryField: {
          visible: true,
          line: {
            type: 'rect',
          },
        },
      },
      legends: {
        visible: true,
      },
    },
  },
  {
    title: 'Radar Chart',
    spec: {
      type: 'radar',
      data: [
        {
          values: [
            {
              month: 'Jan.',
              value: 45,
              type: 'A',
            },
            {
              month: 'Feb.',
              value: 61,
              type: 'A',
            },
            {
              month: 'Mar.',
              value: 92,
              type: 'A',
            },
            {
              month: 'Apr.',
              value: 57,
              type: 'A',
            },
            {
              month: 'May.',
              value: 46,
              type: 'A',
            },
            {
              month: 'Jun.',
              value: 36,
              type: 'A',
            },
            {
              month: 'Jul.',
              value: 33,
              type: 'A',
            },
            {
              month: 'Aug.',
              value: 63,
              type: 'A',
            },
            {
              month: 'Sep.',
              value: 57,
              type: 'A',
            },
            {
              month: 'Oct.',
              value: 53,
              type: 'A',
            },
            {
              month: 'Nov.',
              value: 69,
              type: 'A',
            },
            {
              month: 'Dec.',
              value: 40,
              type: 'A',
            },
            {
              month: 'Jan.',
              value: 31,
              type: 'B',
            },
            {
              month: 'Feb.',
              value: 39,
              type: 'B',
            },
            {
              month: 'Mar.',
              value: 81,
              type: 'B',
            },
            {
              month: 'Apr.',
              value: 39,
              type: 'B',
            },
            {
              month: 'May.',
              value: 64,
              type: 'B',
            },
            {
              month: 'Jun.',
              value: 21,
              type: 'B',
            },
            {
              month: 'Jul.',
              value: 58,
              type: 'B',
            },
            {
              month: 'Aug.',
              value: 72,
              type: 'B',
            },
            {
              month: 'Sep.',
              value: 47,
              type: 'B',
            },
            {
              month: 'Oct.',
              value: 37,
              type: 'B',
            },
            {
              month: 'Nov.',
              value: 80,
              type: 'B',
            },
            {
              month: 'Dec.',
              value: 74,
              type: 'B',
            },
            {
              month: 'Jan.',
              value: 90,
              type: 'C',
            },
            {
              month: 'Feb.',
              value: 95,
              type: 'C',
            },
            {
              month: 'Mar.',
              value: 62,
              type: 'C',
            },
            {
              month: 'Apr.',
              value: 52,
              type: 'C',
            },
            {
              month: 'May.',
              value: 74,
              type: 'C',
            },
            {
              month: 'Jun.',
              value: 87,
              type: 'C',
            },
            {
              month: 'Jul.',
              value: 80,
              type: 'C',
            },
            {
              month: 'Aug.',
              value: 69,
              type: 'C',
            },
            {
              month: 'Sep.',
              value: 74,
              type: 'C',
            },
            {
              month: 'Oct.',
              value: 84,
              type: 'C',
            },
            {
              month: 'Nov.',
              value: 94,
              type: 'C',
            },
            {
              month: 'Dec.',
              value: 23,
              type: 'C',
            },
          ],
        },
      ],
      categoryField: 'month',
      valueField: 'value',
      seriesField: 'type',
      stack: true,
      outerRadius: 1,
      area: {
        visible: true,
      },
      legends: {
        visible: true,
      },
      crosshair: {
        categoryField: {
          visible: true,
          line: {
            type: 'line',
            style: {
              lineWidth: 1,
            },
          },
        },
      },
    },
  },
  {
    title: 'Funnel Chart',
    spec: {
      type: 'funnel',
      categoryField: 'name',
      valueField: 'value',
      isTransform: true,
      isCone: false,
      data: [
        {
          id: 'funnel',
          values: [
            {
              value: 5676,
              name: 'Sent',
            },
            {
              value: 3872,
              name: 'Viewed',
            },
            {
              value: 1668,
              name: 'Clicked',
            },
            {
              value: 610,
              name: 'Add to Cart',
            },
            {
              value: 565,
              name: 'Purchased',
            },
          ],
        },
      ],
      label: {
        visible: true,
      },
      transformLabel: {
        visible: true,
      },
      outerLabel: {
        position: 'right',
        visible: true,
      },
      legends: {
        visible: true,
      },
    },
  },
];
